import * as React from 'react';
import ErrorText from "../../atom/text/error_text";
import Label from "../../atom/label/label";
import FormTextarea from "../../atom/form/form_textarea";
import styled from "styled-components";
import {RefObject} from "react";

interface IProps {
    placeholder: string;
    rows?: number;
    maxRows?: number;
    type: string;
    name: string;
    label: string;
    hasError: boolean;
    errorText: string;
    input?: any;
    textareaRef?: RefObject<HTMLTextAreaElement>;
    require?: boolean;
}

const FormGroupTextarea: React.FC<IProps> = (props) => {

    const {placeholder, type, name, rows, maxRows, label, hasError,
        errorText, children, input, textareaRef, require} = props;

    return (
        <Wrapper>
            {label && <Label require={require} htmlFor={name} marginBottom={true}>{label}</Label>}
            <FormTextarea
                placeholder={placeholder}
                {...input}
                rows={rows}
                maxRows={maxRows}
                type={type}
                hasError={hasError}
                textareaRef={textareaRef}
            >
                {children}
            </FormTextarea>
            {hasError &&
            <ErrorText>{errorText}</ErrorText>
            }
        </Wrapper>
    );
};

export default (FormGroupTextarea);

const Wrapper = styled.div`
    width: 100%;
`;


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/form_group/form_group_textarea.tsx